<template>
  <span class="lh-20">
    <StructuredTextElement
      v-for="(element, index) in text"
      :key="index"
      :element="element"
    />
  </span>
</template>

<script setup>
import StructuredTextElement from '@/shared/components/content/StructuredTextElement.vue';

defineProps({
  text: {
    type: Array,
    default: null,
  },
});
</script>
